/**
 * Every caller feeds a template picker rather than a paginated list — a dropdown in
 * App, ContractInfo, EntryAdministration, the contract-create and index modals and
 * DocumentOverview — so the page has to be large enough to hold a broker's whole
 * template set at once. Deliberately not CONFIG.DEFAULT_FETCH_LIMIT: at 20 those
 * dropdowns would silently drop templates past the twentieth.
 */
var TEMPLATE_PICKER_LIMIT = 100;
export var getTemplatesQuery = function (params) {
    var _a = params || {}, _b = _a.limit, limit = _b === void 0 ? TEMPLATE_PICKER_LIMIT : _b, _c = _a.page, page = _c === void 0 ? 1 : _c;
    return { limit: limit, page: page };
};
